"use strict";

$(function() {
    $('.basket-content').on('click', '.js-basket-line-remove', function(e){
        $(this).closest('.basket-line-quantity')
               .find('input, button')
               .attr('disabled', 'disabled');
    });
});
